// create a new array of team members 
import Justice from './Justice.png';
import Matthew from './Matthew.png';
import Daniel from './Daniel.png';
import Raphael from './Raphael.png';
const team = [{
	name: 'Justice Adu Atakora',
	position:'CEO/Creative Director',
	image: Justice
},
{
	name:'Matthew Amanguah',
	position:'Videographer & Editor',
	image:Matthew
},
{
	name:'Daniel Addo',
	position:'Videographer',
	image:Daniel
},
{
	name:'Raphael Akparibo',
	position:'Videographer & Graphic Designer',
	image:Raphael
}
];


export default team;